// /client/customer/src/utils/reservation/by-service/fetchStoresForServiceReserve.ts
import apiConfig from '../../../apiConfig';

export type ReserveStore = {
  id: number;
  name: string;
  location?: string | null;
  tel?: string | null;
  telegram_url?: string | null;
  instagram_url?: string | null;
  tiktok_url?: string | null;
  messenger_url?: string | null;
};

export type FetchStoresForServiceReserveResponse = {
  stores: ReserveStore[];
};

export const fetchStoresForServiceReserve = async (): Promise<ReserveStore[]> => {
  const res = await fetch(
    `${apiConfig.baseURL}/api/customer-app/reservation/by-service/stores`,
    { method: 'GET' },
  );

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to fetch stores');
  }

  const data = (await res.json()) as FetchStoresForServiceReserveResponse;
  return Array.isArray(data.stores) ? data.stores : [];
};
